import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * TWID generator following Single Responsibility Principle
 */
export class TwidGenerator extends BaseGenerator {
  generate(options = {}) {
    const { gender = null } = options; // 1 for male, 2 for female
    
    const prefixLetters = 'ABCDEFGHJKLMNPQRSTUVXYWZIO';
    const prefix = prefixLetters[this.randomInt(0, prefixLetters.length - 1)];
    
    const genderDigit = gender || (this.randomInt(1, 2));
    const digits = this.randomDigits(7);
    
    const partial = prefix + genderDigit + digits;
    const checksum = ChecksumCalculator.calculateTwidChecksum(partial + '0');
    
    return partial + checksum;
  }
}